import * as React from 'react';
import css from './ServiceFooterLogo.module.scss';

const ServiceFooterLogo = () => {
  return (
    <div className={css.ServiceFooterLogo}>
      <a href="/" className={css.ServiceFooterLogo__Logo}>
        <svg className={css.ServiceFooterLogo__LogoImg}>
          <use xlinkHref={'#logo-brand'} />
        </svg>
      </a>
    </div>
  );
};

export default ServiceFooterLogo;
